import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { titleStyles, valueStyles, wrapperStyles } from './HoverDescriptionItem.styles';

const HoverDescriptionItem = ({ title, value }) => (
  <Box sx={wrapperStyles}>
    <Typography sx={titleStyles} variant="regular14">
      {title}
    </Typography>
    <Typography sx={valueStyles} variant="regular14">
      {value}
    </Typography>
  </Box>
);

HoverDescriptionItem.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default HoverDescriptionItem;
